// Single source of truth for the CRM pipeline.
// Add a status here and it propagates everywhere (filters, stats, badges).

export const STATUS_OPTIONS = [
  { v: "new", fr: "Nouveau", en: "New", color: "#C5A059" },
  { v: "in_progress", fr: "Contacté", en: "Contacted", color: "#7CC5C5" },
  { v: "quote_sent", fr: "Devis envoyé", en: "Quote sent", color: "#E8C66C" },
  { v: "won", fr: "Gagné", en: "Won", color: "#7CC57F" },
  { v: "lost", fr: "Perdu", en: "Lost", color: "#E27474" },
  { v: "archived", fr: "Archivé", en: "Archived", color: "#A19E9C" },
];

export const FOLLOWUP_DELAY_DAYS = 5;

export const statusMeta = (v) =>
  STATUS_OPTIONS.find((s) => s.v === v) || STATUS_OPTIONS[0];

export const daysSince = (iso) => {
  if (!iso) return null;
  try {
    const diff = Date.now() - new Date(iso).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  } catch {
    return null;
  }
};

// A row is "follow-up due" when:
//   - status = quote_sent
//   - status changed > N days ago
//   - no follow-up has ever been sent
export const isFollowupDue = (req) => {
  if (req.status !== "quote_sent") return false;
  if (req.last_followup_sent_at) return false;
  const since = daysSince(req.status_changed_at || req.created_at);
  return since !== null && since >= FOLLOWUP_DELAY_DAYS;
};

export const formatContactDate = (iso, lang) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString(lang === "fr" ? "fr-FR" : "en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
